export const REPORT_ALL_FRONTLINE_CLIENTS = 'REPORT_ALL_FRONTLINE_CLIENTS';
export const REPORT_ALL_GEN0_CLIENTS = 'REPORT_ALL_GEN0_CLIENTS';
export const REPORT_ALL_ORGANIZATION_CLIENTS =
  'REPORT_ALL_ORGANIZATION_CLIENTS';
export const REPORT_NEW_FRONTLINE_CLIENTS = 'REPORT_NEW_FRONTLINE_CLIENTS';
export const REPORT_NEW_GEN0_CLIENTS = 'REPORT_NEW_GEN0_CLIENTS';
export const REPORT_NEW_ORGANIZATION_CLIENTS =
  'REPORT_NEW_ORGANIZATION_CLIENTS';
export const REPORT_ALL_FRONTLINE_ORDERS = 'REPORT_ALL_FRONTLINE_ORDERS';
export const REPORT_ALL_ORDERS = 'REPORT_ALL_ORDERS';
export const REPORT_ALL_GEN0_ORDERS = 'REPORT_ALL_GEN0_ORDERS';
export const REPORT_ALL_ORGANIZATION_ORDERS = 'REPORT_ALL_ORGANIZATION_ORDERS';
export const REPORT_NEW_FRONTLINE_ORDERS = 'REPORT_NEW_FRONTLINE_ORDERS';
export const REPORT_NEW_GEN0_ORDERS = 'REPORT_NEW_GEN0_ORDERS';
export const REPORT_NEW_ORGANIZATION_ORDERS = 'REPORT_NEW_ORGANIZATION_ORDERS';
export const REPORT_PREMIER_CANCELLATIONS = 'REPORT_PREMIER_CANCELLATIONS';
export const REPORT_PROJECTED_PREMIER_VOLUME =
  'REPORT_PROJECTED_PREMIER_VOLUME';
export const REPORT_NEW_CLIENTS_WITHOUT_ORDERS =
  'REPORT_NEW_CLIENTS_WITHOUT_ORDERS';
export const REPORT_RANK_UP = 'REPORT_RANK_UP';
export const REPORT_ELIGIBLE_FOR_CAB = 'REPORT_ELIGIBLE_FOR_CAB';
export const REPORT_ELIGIBLE_FOR_QSB = 'REPORT_ELIGIBLE_FOR_QSB';
export const REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK =
  'REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK';
export const REPORT_CLOSE_TO_FIBC_RANK = 'REPORT_CLOSE_TO_FIBC_RANK';
export const REPORT_CLOSE_TO_SENIOR_COACH_RANK =
  'REPORT_CLOSE_TO_SENIOR_COACH_RANK';
export const REPORT_TEAMS_EXECUTIVE_DIRECTOR =
  'REPORT_TEAMS_EXECUTIVE_DIRECTOR';
export const REPORT_TEAMS_FIBC = 'REPORT_TEAMS_FIBC';
export const REPORT_TEAMS_FIBL = 'REPORT_TEAMS_FIBL';
export const REPORT_TEAMS_SENIOR_COACH = 'REPORT_TEAMS_SENIOR_COACH';
export const REPORT_EXPIRING_COACH_RENEWAL = 'REPORT_EXPIRING_COACH_RENEWAL';
export const REPORT_COACHES_AT_RANK = 'REPORT_COACHES_AT_RANK';
export const REPORT_COACHES_BELOW_RANK = 'REPORT_COACHES_BELOW_RANK';
export const REPORT_COACHES_ABOVE_RANK = 'REPORT_COACHES_ABOVE_RANK';
export const REPORT_ALL_FRONTLINE_COACHES = 'REPORT_ALL_FRONTLINE_COACHES';
export const REPORT_NEW_FRONTLINE_COACHES = 'REPORT_NEW_FRONTLINE_COACHES';
export const REPORT_ALL_GEN0_COACHES = 'REPORT_ALL_GEN0_COACHES';
export const REPORT_NEW_GEN0_COACHES = 'REPORT_NEW_GEN0_COACHES';
export const REPORT_ALL_COACHES_IN_ORGANIZATION =
  'REPORT_ALL_COACHES_IN_ORGANIZATION';
export const REPORT_NEW_COACHES_IN_ORGANIZATION =
  'REPORT_NEW_COACHES_IN_ORGANIZATION';
export const MY_TEAMS = 'MY_TEAMS';
export const VIEW_TEAMS = 'VIEW_TEAMS';

export const REPORT_WATCH_LIST = 'REPORT_WATCH_LIST';
export const REPORT_EARNED_CAB = 'REPORT_EARNED_CAB';
export const REPORT_EARNED_QSB = 'REPORT_EARNED_QSB';
export const REPORT_NOT_CERTIFIED = 'REPORT_NOT_CERTIFIED';
export const REPORT_INACTIVE_CLIENTS = 'REPORT_INACTIVE_CLIENTS';
export const REPORT_EXPIRING_WELLNESS = 'REPORT_EXPIRING_WELLNESS';
export const REPORT_EXPIRING_REWARDS = 'REPORT_EXPIRING_REWARDS';
export const SEARCH = 'SEARCH';
export const REPORT_FRONTLINE_COACHES = 'REPORT_FRONTLINE_COACHES';
export const REPORT_ELIGIBLE_ACCELERATOR_BONUS =
  'REPORT_ELIGIBLE_ACCELERATOR_BONUS';
export const REPORT_EARNED_ACCELERATOR_BONUS =
  'REPORT_EARNED_ACCELERATOR_BONUS';
export const REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS =
  'REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS';

export const REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR =
  'REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR';

export const REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE =
  'REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE';

export const REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX =
  'REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX';

export const REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO =
  'REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO';

export const REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS =
  'REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS';
export const REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP =
  'REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP';
export const REPORT_QUALIFIED_FOR_INCENTIVE_TRIP =
  'REPORT_QUALIFIED_FOR_INCENTIVE_TRIP';

export const REPORT_CLIENT_TO_CONTACT = 'REPORT_CLIENT_TO_CONTACT';

export const REPORT_CLIENT_TO_CONTACT_NO_ORDER =
  'REPORT_CLIENT_TO_CONTACT_NO_ORDER';
export const REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE =
  'REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE';
export const REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION =
  'REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION';
export const REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS =
  'REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS';
export const REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS =
  'REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS';
export const REPORT_CLIENT_TO_CONTACT_NEXT_TASK =
  'REPORT_CLIENT_TO_CONTACT_NEXT_TASK';
export const REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER =
  'REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER';
export const REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER =
  'REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER';
export const REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE =
  'REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE';

export const REPORTS_WITHOUT_PAGINATION = [
  REPORT_PROJECTED_PREMIER_VOLUME,
  REPORT_ALL_ORGANIZATION_ORDERS,
  REPORT_ALL_ORDERS,
];
export const REPORT_ALL_CANDIDATES = 'REPORT_ALL_CANDIDATES';
export const CREATE_NEW_CANDIDATE = 'CREATE_NEW_CANDIDATE';
export const REPORT_BUSINESS_BUILDER_COACHES =
  'REPORT_BUSINESS_BUILDER_COACHES';
export const BUSINESS_BUILDER_COACHES = 'Business Builder Coaches';
export const REPORT_ALL_REFERRALS = 'REPORT_ALL_REFERRALS';

export const MANAGE_MY_SITE = 'MANAGE_MY_SITE';
export const HEALTH_CARE_PROVIDER = 'HEALTH_CARE_PROVIDER';
export const PROFILE_ORDER_HISTORY = 'PROFILE_ORDER_HISTORY';
export const REPORT_VOLUME_PERFORMANCE = 'REPORT_VOLUME_PERFORMANCE';
export const ORDER_DETAILS = 'ORDER_DETAILS';
export const CLIENT_PROFILE = 'CLIENT_PROFILE';
export const ORDER_HISTORY_LIST_SCREEN = 'ORDER_HISTORY_LIST_SCREEN';
